// Chasing Ghosts Metadata.
import ChasingGhostsSVG from '../../../assets/images/Thoughts/ChasingGhosts.svg';

const ChasingGhostsMetadata = {
  id: 'ChasingGhosts',
  title: 'Chasing Ghosts',
  description: 'The Pursuit of Shadows',
  thumbnail: ChasingGhostsSVG,
  featured: false,
};

export default ChasingGhostsMetadata;
